import { render, staticRenderFns } from "./GKS3Uploader.vue?vue&type=template&id=595485c2&scoped=true&"
import script from "./GKS3Uploader.vue?vue&type=script&lang=js&"
export * from "./GKS3Uploader.vue?vue&type=script&lang=js&"
import style0 from "./GKS3Uploader.vue?vue&type=style&index=0&id=595485c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595485c2",
  null
  
)

export default component.exports